<div class="main-content">
	<div class="container-fluid">
		<mat-card class="feature-surface">
			<mat-card-header>
				<mat-card-title>Vendor-Backed Receivables</mat-card-title>
				<mat-card-subtitle>
					Open supplier credits from prior vendor-backed AR receipts — waiting for the actual deposit to clear
				</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>

				<!-- Top tiles -->
				<div *ngIf="!loading">
					<div class="feature-tile-row">
						<app-kpi-tile
							tone="accent"
							label="open total"
							[value]="'$' + (totals.open_balance | number:'1.2-2')"
							[sub]="totals.open_invoices + ' invoices · ' + vendors.length + ' vendors'">
						</app-kpi-tile>
						<app-kpi-tile *ngFor="let v of vendors | slice:0:4"
							[tone]="v.oldest_age_days > 30 ? 'partial' : 'default'"
							[label]="v.suppname"
							[value]="'$' + (v.open_balance | number:'1.2-2')"
							[sub]="v.open_invoices + ' inv · ' + v.oldest_age_days + 'd'">
						</app-kpi-tile>
					</div>
				</div>

				<!-- All vendors table -->
				<h5 class="mt-4">All open vendors</h5>
				<table class="feature-table" *ngIf="!loading">
					<thead>
						<tr>
							<th>Vendor</th>
							<th class="is-num">Open AR $</th>
							<th class="is-num">Invoices</th>
							<th class="is-num">Oldest</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let v of vendors">
							<td><strong>{{ v.suppname }}</strong></td>
							<td class="is-num">{{ v.open_balance | currency }}</td>
							<td class="is-num">{{ v.open_invoices }}</td>
							<td class="is-num">{{ v.oldest_age_days }} d</td>
							<td><button mat-stroked-button color="accent" (click)="openDetail(v)">Drill</button></td>
						</tr>
						<tr *ngIf="!vendors.length">
							<td colspan="5" class="text-center text-muted">No open vendor-backed balances 🎉</td>
						</tr>
					</tbody>
				</table>

				<div *ngIf="loading" class="text-center my-4">
					<mat-progress-spinner diameter="32" mode="indeterminate" color="accent"></mat-progress-spinner>
				</div>

				<!-- Vendor drill panel -->
				<div *ngIf="selectedVendor" class="feature-section mt-4">
					<div class="d-flex justify-content-between align-items-center mb-2">
						<p class="feature-section__title m-0">{{ selectedVendor.suppname }} · open credits</p>
						<button mat-icon-button (click)="closeDetail()" aria-label="Close">
							<i class="material-icons">close</i>
						</button>
					</div>

					<table class="feature-table">
						<thead>
							<tr>
								<th></th>
								<th>Trandate</th>
								<th>Customer</th>
								<th>AR ref</th>
								<th class="is-num">Open balance</th>
								<th class="is-num">Age</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let r of detailRows">
								<td><mat-checkbox [(ngModel)]="selectedIds[r.id]"></mat-checkbox></td>
								<td>{{ r.trandate | date }}</td>
								<td>{{ r.customer_name }}</td>
								<td>{{ r.ar_transno }}</td>
								<td class="is-num">{{ r.open_balance | currency }}</td>
								<td class="is-num">{{ r.age_days }} d</td>
							</tr>
							<tr *ngIf="!loadingDetail && !detailRows.length">
								<td colspan="6" class="text-center text-muted">none</td>
							</tr>
						</tbody>
					</table>

					<div class="d-flex justify-content-between align-items-center mt-3">
						<small class="text-muted">
							{{ selectedCount }} selected · {{ selectedTotal | currency }}
						</small>
						<button mat-flat-button color="accent" [disabled]="!selectedCount" (click)="openApply()">
							Apply bank deposit
						</button>
					</div>
				</div>

			</mat-card-content>
		</mat-card>
	</div>
</div>

<!-- Apply deposit dialog -->
<ng-template #applyDialog>
	<h2 mat-dialog-title>Apply bank deposit · {{ selectedVendor?.suppname }}</h2>
	<form [formGroup]="applyForm" mat-dialog-content>
		<mat-form-field appearance="outline" class="w-100 mt-2">
			<mat-label>Bank account</mat-label>
			<mat-select formControlName="bankaccount">
				<mat-option *ngFor="let b of bankaccounts" [value]="b.accountcode">{{ b.bankaccountname }}</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="w-100">
			<mat-label>Deposit date</mat-label>
			<input matInput type="date" formControlName="postdate">
		</mat-form-field>
		<mat-form-field appearance="outline" class="w-100">
			<mat-label>Deposit amount</mat-label>
			<span matPrefix>$&nbsp;</span>
			<input matInput type="number" step="0.01" min="0" formControlName="deposit_amount">
		</mat-form-field>
		<p class="text-muted" style="font-size: 12px;">
			Selected {{ selectedCount }} credits totaling {{ selectedTotal | currency }}.
			Any difference will be left on the deposit as unapplied (handle in vendor inquiry later).
		</p>
	</form>
	<div mat-dialog-actions class="d-flex justify-content-end" style="gap: 8px;">
		<button mat-stroked-button mat-dialog-close>Cancel</button>
		<button mat-flat-button color="accent" [disabled]="applying || !applyForm.valid" (click)="postApply()">
			{{ applying ? 'Posting…' : 'Apply' }}
		</button>
	</div>
</ng-template>
